import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { CostSettingProfile } from 'lumen/models';
import type {
  CommissionMode,
  CostValuesView,
  CostValueType,
} from 'lumen/utils/net-revenue/cost/types';

export default class CostSettingCostModel extends Model {
  [Type] = 'cost-setting/cost' as const;

  @belongsTo('cost-setting/profile', { async: false, inverse: 'costs' })
  declare profile: CostSettingProfile;

  @attr('string') declare commissionType: CommissionMode;
  /** Beta only supports "room_night"; it lives here for the same reason as `costType`. */
  @attr('string', { defaultValue: 'room_night' }) declare costBasis: string;
  /** Only commissions exist today; it lives here so the serializer owns the whole payload. */
  @attr('string', { defaultValue: 'commission' }) declare costType: string;
  @attr('cost-values') declare costValues: CostValuesView;
  @attr('string') declare valueType: CostValueType;
}
